import { FFDSettings, ScreenApi } from 'kiolyn-api';
import IFrontFacingDisplayRepository from '../domain/repositories/IFrontFacingDisplayRepository';

export class FrontFacingDisplayRepository
  implements IFrontFacingDisplayRepository {
  private readonly api: ScreenApi;

  constructor(basePath: string) {
    this.api = new ScreenApi({
      basePath
    });
  }

  public async loadFrontFacingDisplay(storeid: string): Promise<FFDSettings> {
    const r = await this.api.loadFrontFacingDisplay(storeid);
    return r.data;
  }
}
